import { render, staticRenderFns } from "./BookLesson.vue?vue&type=template&id=94ca4bfc&"
import script from "./BookLesson.vue?vue&type=script&lang=js&"
export * from "./BookLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports